import React, { useMemo } from 'react';
import { formatUKDate, formatUKTime, renderPaidHours, minutesToHoursMinutes } from '../../utils/attendanceDateTime';

export default function TodaySummaryCard({ activeShift, recentShifts }) {
  const todayShift = useMemo(() => {
    if (activeShift) return activeShift;

    const today = new Date().toDateString();
    return (recentShifts || []).find((row) => {
      const date = row.clock_in_at || row.shift_date;
      return date ? new Date(date).toDateString() === today : false;
    });
  }, [activeShift, recentShifts]);

  return (
    <section className="card-rtb" data-testid="today-summary-card">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-2xl uppercase text-white">Today Summary</h3>
        <p className="text-[#A1A1AA] text-sm">{formatUKDate(new Date())}</p>
      </div>

      {!todayShift ? (
        <p className="text-[#A1A1AA] text-sm mt-3">No shift recorded yet today.</p>
      ) : (
        <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          <div className="rounded-md border border-[#3F3F46] bg-[#121212] px-3 py-3">
            <p className="text-[#A1A1AA] text-xs uppercase">Venue</p>
            <p className="text-white mt-1 text-sm">{todayShift.venue_name || 'Assigned venue'}</p>
          </div>
          <div className="rounded-md border border-[#3F3F46] bg-[#121212] px-3 py-3">
            <p className="text-[#A1A1AA] text-xs uppercase">Clock In</p>
            <p className="text-white mt-1 text-sm">{formatUKTime(todayShift.clock_in_at)}</p>
          </div>
          <div className="rounded-md border border-[#3F3F46] bg-[#121212] px-3 py-3">
            <p className="text-[#A1A1AA] text-xs uppercase">Break Total</p>
            <p className="text-white mt-1 text-sm">{minutesToHoursMinutes(todayShift.break_minutes || 0)}</p>
          </div>
          <div className="rounded-md border border-[#3F3F46] bg-[#121212] px-3 py-3">
            <p className="text-[#A1A1AA] text-xs uppercase">Paid Hours</p>
            <p className="text-white mt-1 text-sm">
              {todayShift.clock_out_at ? renderPaidHours(todayShift.paid_hours || 0) : 'In progress'}
            </p>
          </div>
        </div>
      )}
    </section>
  );
}
